import { IArrowLeftTrailerProps } from "interfaces";

const ArrowLeftTrailerIcon = ({ className, onClick }: IArrowLeftTrailerProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className}
             onClick={onClick}>
            <path
                d="M11.8795 27.56C11.6261 27.56 11.3728 27.4667 11.1728 27.2667C10.7861 26.88 10.7861 26.24 11.1728 25.8534L19.8661 17.16C20.5061 16.52 20.5061 15.48 19.8661 14.84L11.1728 6.14669C10.7861 5.76003 10.7861 5.12003 11.1728 4.73336C11.5595 4.34669 12.1995 4.34669 12.5861 4.73336L21.2795 13.4267C21.9595 14.1067 22.3461 15.0267 22.3461 16C22.3461 16.9734 21.9728 17.8934 21.2795 18.5734L12.5861 27.2667C12.3861 27.4534 12.1328 27.56 11.8795 27.56Z"/>
        </svg>
    )
}
export default ArrowLeftTrailerIcon;